export default __webpack_public_path__ + "static/media/creditCardTemplate.629f1a97.svg";